var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 55,
    viewBox: "0 0 40 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #002c5f;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20083",
    "data-name": "Group 20083",
    transform: "translate(-1344 -614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19320",
    "data-name": "Group 19320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7611",
    "data-name": "Path 7611",
    className: "cls-1",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(1344 614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    className: "cls-1",
    d: "M9.518,6.161a4,4,0,0,1,6.965,0l6.144,10.871A4,4,0,0,1,19.144,23H6.856a4,4,0,0,1-3.482-5.968Z",
    transform: "translate(1377 669) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    className: "cls-2",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1347 617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    className: "cls-3",
    d: "M15.719,23.974a4.034,4.034,0,0,1-.784,2.7A2.542,2.542,0,0,1,12.642,28a23.292,23.292,0,0,1-6.352-.974.39.39,0,0,1-.231-.165.274.274,0,0,1,.1-.3A18.754,18.754,0,0,1,12.3,23.685a6.255,6.255,0,0,1,2.549-.363,1.111,1.111,0,0,1,.874.65M23.236,19.6c1.023.842,1.947,1.988,1.633,3.374-.512,2.046-2.739,3.134-4.512,3.827a13.384,13.384,0,0,1-2.995.751c-.066-.008-.173.008-.19-.091l.025-.116a26.668,26.668,0,0,0,3.637-5.509c.462-.867.891-1.758,1.288-2.631a.424.424,0,0,1,.183-.124,2.138,2.138,0,0,1,.932.52m-14.4-2.179-.033.124a34.189,34.189,0,0,0-4.949,8.175c-.264.248-.52-.082-.759-.19-1.2-.791-2.294-2.069-1.98-3.589.5-1.979,2.541-3.035,4.24-3.752a15.907,15.907,0,0,1,3.159-.859c.116,0,.264-.016.322.091m10.766.4c.124.066.272.091.347.213.066.14-.066.231-.14.322a17.835,17.835,0,0,1-5.66,2.731,6.819,6.819,0,0,1-3.168.445,1.049,1.049,0,0,1-.65-.5,2.973,2.973,0,0,1,.429-2.26c.437-.85,1.214-1.848,2.285-1.864a23.634,23.634,0,0,1,6.559.91m2.854.066c1.749.957,3.728,2.64,3.523,4.883-.239,2.081-2.178,3.53-3.91,4.4a23.086,23.086,0,0,1-17.381.379c-1.768-.737-3.748-2-4.49-3.9A4.017,4.017,0,0,1,1.49,19.4c2.435-2.211,5.535-2.969,8.728-3.408A23.477,23.477,0,0,1,20.429,17a16.453,16.453,0,0,1,2.029.883",
    transform: "translate(1351.001 610.559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMap);
export default __webpack_public_path__ + "static/media/location_map.1238939b367a614595f25f2ff8f245cc.svg";
export { ForwardRef as ReactComponent };